import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { bonuses, included, volumes } from '../data/offer';
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-129" data-mp="18710a20b07v9">
        <div className="mx-auto max-w-5xl" data-id="element-130" data-mp="1d6nf2fvs5w66">
          <header className="text-center" data-id="element-131" data-mp="1d5ca4cqlmidh">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-132" data-mp="yi0vg1z4ei95">
              🏆 SISTEMA INFORMACIÓN BAJO CONTROL™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" data-id="element-133" data-mp="13aaina8up47q">
              Tu método en 3 volúmenes para organizar y gestionar la información sobre la epilepsia de tu hijo sin saturarte.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-slate-400" data-id="element-134" data-mp="ue1jlwosc7m4">
              Contenido educativo y organizativo. Complementa el seguimiento médico; no lo
              reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-135" data-mp="3let6g8sho5z9">📚 3 VOLÚMENES</h3>
          </header>
          <div className="mt-7 space-y-5" data-id="element-136" data-mp="3gg8c2pzx4giq">
            {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex gap-5 rounded-2xl border ${volume.border} bg-brand-ink p-5 sm:p-7`} data-id="element-137" data-mp="3ufhk32dz04bm" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-138" data-mp="3bh59dc7eumdx" />
                <div data-id="element-139" data-mp="36pwy0amisqy4">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-140" data-mp="36pdi0zgfkcmq">{volume.title}</h4>
                  <ul className="mt-4 space-y-2" data-id="element-141" data-mp="2iz9oxm0vbv9z">
                    {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-142" data-mp="2ey7ox2z4nf6y">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-143" data-mp="mwedr29047sg" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-144" data-mp="3ybu72z83321">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-145" data-mp="8x5af35w985w">El Sistema incluye:</h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-146" data-mp="dwhyfr8i4la2">
              {included.map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-147" data-mp="1kd3ltdojo6aa">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-148" data-mp="1kf6d011fo5gl" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-149" data-mp="34vny32qdsjlw">
        <div className="mx-auto max-w-5xl" data-id="element-150" data-mp="303e0d0j0yf92">
          <header className="text-center" data-id="element-151" data-mp="3022yj6953hkl">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-152" data-mp="2v5kxohgxk3dj" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-153" data-mp="2q5q8cicszlul">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-154" data-mp="2m2tj48srcrho">SIEMPRE INCLUIDOS</p>
          </header>
          <div className="mt-10 space-y-4" data-id="element-155" data-mp="2h5tkuk25gt14">
            {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-156" data-mp="2c7idcfzbuum2">
                <span className="w-fit whitespace-nowrap rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-157" data-mp="afdd8h7ocr09">
                  BONO {bonus.number}
                </span>
                <div className="flex-1" data-id="element-158" data-mp="38740zo9g8pwe">
                  <h3 className="font-bold" data-id="element-159" data-mp="3862n7c11tpaz">{bonus.title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-160" data-mp="2u7un4v8pu7vl">
                    {bonus.details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-161" data-mp="2z65sotrz9w80">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-162" data-mp="2kh9r9fkffhgd" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-163" data-mp="2gf4xmgtzaktq">
                  <span className="text-sm text-slate-500 line-through" data-id="element-164" data-mp="21l9u7qcldnpx">{bonus.value}</span>
                  <span className="whitespace-nowrap rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-165" data-mp="26i09ibgkofaa">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-166" data-mp="1iy0zwrl8oj0k">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-167" data-mp="1rwcoko2jp6qd">VALOR TOTAL BONOS</p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-168" data-mp="25w462ys9t594">$52.000</p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-169" data-mp="25trh41o3humk">
              GRATIS con tu Sistema Información Bajo Control™
            </p>
          </div>
        </div>
      </section>
    </>;
}